<template>
  <export-pdf :loading="loading" :filename="filename" :title="title" :subtitle="subtitle">
    <mf-pdf-item v-if="personType === 'F'" title="Faixa etária" :name="$getLoggedUser().client">
      <div class="full-width">
        <faixa-etaria-card is-pdf />
      </div>
    </mf-pdf-item>

    <mf-pdf-item title="Cidades" :name="$getLoggedUser().client">
      <div class="full-width">
        <cidade-card :tipo-pessoa="personType" is-pdf />
      </div>
    </mf-pdf-item>

    <mf-pdf-item title="Bairros" :name="$getLoggedUser().client">
      <div class="full-width">
        <bairro-card :tipo-pessoa="personType" is-pdf />
      </div>
    </mf-pdf-item>

    <mf-pdf-item v-if="personType === 'F'" title="Gênero" :name="$getLoggedUser().client">
      <div class="full-width">
        <genero-card is-pdf />
      </div>
    </mf-pdf-item>
  </export-pdf>
</template>

<script>
import ExportPdf from '@/components/ExportPdf.vue'
import FaixaEtariaCard from '@/modules/clientes/perfil-demografico/views/pages/FaixaEtariaCard.vue'
import CidadeCard from '@/modules/clientes/perfil-demografico/views/pages/CidadeCard.vue'
import BairroCard from '@/modules/clientes/perfil-demografico/views/pages/BairroCard.vue'
import GeneroCard from '@/modules/clientes/perfil-demografico/views/pages/GeneroCard.vue'
import { DateTime } from 'luxon'
export default {
  name: 'DemographicProfilePdf',
  components: { ExportPdf, FaixaEtariaCard, CidadeCard, BairroCard, GeneroCard },
  props: {
    personType: {
      type: String,
      default: 'F',
    },
  },
  computed: {
    filename() {
      return this.personType === 'F' ? 'perfil_demografico_pessoa_fisica' : 'perfil_demografico_pessoa_juridica'
    },
    title() {
      return this.personType === 'F' ? 'Perfil demográfico - Pessoa física' : 'Perfil demográfico - Pessoa jurídica'
    },
    subtitle() {
      const formattedDate = DateTime.now().setLocale('pt-BR').toFormat('LLLL yyyy')
      return formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1)
    },
    loading() {
      return this.$wait.is([
        'last-update',
        'primeiro-registro',
        'faixa',
        'cidade-fisica',
        'cidade-juridica',
        'geo-status',
        'bairro-fisica',
        'bairro-juridica',
        'genero',
      ])
    },
  },
}
</script>

<style lang="scss" scoped>
.full-width {
  width: 100%;
}
</style>
